import AskklogDev from "./AskklogDev";

export default AskklogDev;
